import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "view-table box" }
const _hoisted_2 = { class: "view-table__header" }
const _hoisted_3 = { class: "view-table__description" }
const _hoisted_4 = { class: "view-table__pagination" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Страница", -1)
const _hoisted_6 = ["max"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "из", -1)
const _hoisted_8 = {
  key: 0,
  class: "table is-hoverable is-bordered"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "th-number" }, "№"),
    /*#__PURE__*/_createElementVNode("th", null, "Сумма"),
    /*#__PURE__*/_createElementVNode("th", null, "БИК банка"),
    /*#__PURE__*/_createElementVNode("th", null, "Расчетный счет"),
    /*#__PURE__*/_createElementVNode("th", null, "Бухгалтер"),
    /*#__PURE__*/_createElementVNode("th", null, "Статус"),
    /*#__PURE__*/_createElementVNode("th", null, "Дата")
  ])
], -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "table-container__empty"
}
const _hoisted_12 = {
  key: 0,
  class: "view-table_options"
}
const _hoisted_13 = { class: "view-table_options__content box is-radiusless" }
const _hoisted_14 = { class: "field mt-auto" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Показывать по", -1)
const _hoisted_16 = { class: "control" }
const _hoisted_17 = { class: "select" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сортировка", -1)
const _hoisted_21 = { class: "control" }
const _hoisted_22 = { class: "select" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "view-table_options__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCard = _resolveComponent("ModalCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Всего найдено " + _toDisplayString(_ctx.ctx.meta.total), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "number",
          min: "1",
          max: _ctx.ctx.meta.page.total,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePage && _ctx.changePage(...args)))
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.page]
        ]),
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_ctx.ctx.meta.page.total), 1)
      ]),
      _createElementVNode("button", {
        class: "button is-info",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOptions = true))
      }, "Опции")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["table-container with-scrollbar", {'busy':_ctx.ctx.isLoading, 'lock': _ctx.showOptions}]),
      id: "table"
    }, [
      (_ctx.ctx.list.length)
        ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.list, (order) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "is-clickable",
                  key: order.id,
                  onClick: ()=>_ctx.selectedOrder = order
                }, [
                  _createElementVNode("td", null, _toDisplayString(order.id), 1),
                  _createElementVNode("td", null, _toDisplayString(order.amount), 1),
                  _createElementVNode("td", null, _toDisplayString(order.bic), 1),
                  _createElementVNode("td", null, _toDisplayString(order.check_acc), 1),
                  _createElementVNode("td", null, _toDisplayString(order.user && order.user.name), 1),
                  _createElementVNode("td", null, _toDisplayString(order.status.system_name), 1),
                  _createElementVNode("td", null, _toDisplayString(order.created_at), 1)
                ], 8, _hoisted_10))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_11, "Пусто"))
    ], 2),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "view-table_options__overlay",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("p", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.limit) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.LimitPageVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant.value,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_18))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.limit]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("p", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sorting) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.sortingVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_23))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.sorting]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "button is-primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
              }, "Применить"),
              _createElementVNode("button", {
                class: "button is-ghost",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "Сбросить"),
              _createElementVNode("button", {
                class: "button is-light",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, "Отмена")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalCard, {
      order: _ctx.selectedOrder,
      onClose: _ctx.closeModalWindow
    }, null, 8, ["order", "onClose"])
  ]))
}